module.exports = __webpack_public_path__ + "img/rg-vessel-danger.f1e514a5.svg";